import { __assign } from "tslib";
import { AuthType, } from '@office-start/auth-types';
import { parseConfig } from '@office-start/config-parser-utility';
var identityKey = 'identity';
export function readIdentity() {
    var domIdentity = parseConfig(identityKey);
    var identity = __assign(__assign({}, domIdentity), { isMsa: (domIdentity === null || domIdentity === void 0 ? void 0 : domIdentity.authType) === AuthType.MSA, isOrgId: (domIdentity === null || domIdentity === void 0 ? void 0 : domIdentity.authType) === AuthType.OrgId });
    return identity;
}
//# sourceMappingURL=readIdentity.js.map